class Monitoring.Models.SurveyItemFilter extends Backbone.Model

  initialize: (code, values) ->
    @code = code
    @values = values

  shouldBeRendered: ->
    @values.terms.length > 0

  filter_code: ->
    @code
